export enum RoutesEnum {
  Default = '/',
  Login = '/login',
  Logout = '/logout',
  SignUp = '/signup/:id',
  Dashboard = '/dashboard',
  DashboardLegacy = '/dashboard-legacy',
  Callback = '/callback',
  SilentRenew = '/silentrenew',
  Members = '/members/register',
  SendingOrderDetail = '/sendingorder/view/:id', // TODO: kolla om :id ska ligga här eller bara i rutten
  Sending = '/sending',
  SendingCompleted = '/sending/avslutade',
  CreateSendingOrder = '/sendingorder/create',
  EditSendingOrder = '/sendingorder/edit',
  EditMember = '/member/edit',
  ImportMembers = '/membersimport',
  ImportMembersUpload = '/membersimport/upload',
  ImportMembersSessions = '/membersimport/sessions',
  MemberDetails = '/members/register', // NOTE: Tog bort /:id här då navigering till member slutade funka på en del ställen. Sofie 2023-02-16
  MemberUpdates = '/members/updates',
  MemberOverview = '/members/overview',
  MemberAdvancedSearch = '/members/register/search',
  MemberSelection = '/members/register/selection',
  MemberInvoiceAddress = '/members/invoiceaddress',
  MemberOtherContact = '/othercontact/register',
  MemberOtherContactDetails = '/othercontact/register',
  MemberOtherContactAdvancedSearch = '/othercontact/register/search',
  Mailings = '/mailings',
  MyExports = '/me/exports',
  GroupMessageEmailOverview = '/groupmessage/email',
  GroupMessageEmailCreate = '/groupmessage/email/create',
  GroupMessageEmailCreateFromTemplate = '/groupmessage/email/create/template',
  GroupMessageEmailEdit = '/groupmessage/email/edit',
  GroupMessageEmailUnsubscribed = '/groupmessage/email/unsubscribed',
  GroupMessageEmailTemplates = '/groupmessage/email/templates',
  GroupMessageSmsOverview = '/groupmessage/sms',
  GroupMessageSmsCreate = '/groupmessage/sms/create',
  GroupMessageSmsEdit = '/groupmessage/sms/edit',
  GroupMessageSmsUnsubscribed = '/groupmessage/sms/unsubscribed',
  Gifts = '/gifts/register',
  GiftsDetail = '/gifts/register',
  Donors = '/gifts/donors',
  DonorsDetail = '/gifts/donors',
  InvoiceDashboard = '/invoicing',
  Invoices = '/invoicing/invoices',
  InvoicesDetail = '/invoicing/invoices',
  InvoiceArticleRegister = '/invoicing/articles',
  InvoiceArticleCategory = '/invoicing/articles/categories',
  IncomingBankPayment = '/invoicing/incoming-payments',
  Autogiro = '/autogiro',
  Memberautogirostatus = '/autogiro/memberautogirostatus',
  AutogiroCreateFile = '/autogiro/create-file',
  EInvoice = '/einvoice',
  EInvoiceLinkedMembers = '/einvoice/linkedmembers',
  EInvoiceLinkedOthers = '/einvoice/linkedothers',
  EInvoiceApplications = '/einvoice/applications',
  PaymentTransactions = '/invoicing/accounting',
  PaymentAccounting = '/invoicing/accounting/records',
  PaymentDistribution = '/invoicing/accounting/distribution',
  DocumentArchiveOverview = '/files',
  DocumentCategoryOverview = '/files/categories',
  Events = '/events',
  EventsCalendar = '/events/calendar',
  Settings = '/settings',
  Users = '/settings/users',
  UsersSettings = '/settings/users/settings',
  UserDetails = '/settings/user',
  MemberFees = '/settings/member-fees',
  MemberProfileGroup = '/settings/profile',
  MemberProfileDetail = '/settings/profile',
  WebFormSettings = '/settings/webforms',
  AutojobSettings = '/settings/autojobs',
  MemberRegistrySettings = '/settings/member-registry',
  MemberRegistrySettingsGeneral = '/settings/member-registry/general',
  MemberRegistrySettingsForms = '/settings/member-registry/forms',
  MemberRegistrySettingsFormMember = '/settings/member-registry/forms/member',
  MemberRegistrySettingsFormOther = '/settings/member-registry/forms/other',
  MemberRegistrySettingsFormMypage = '/settings/member-registry/forms/mypage',
  MemberRegistrySettingsWebForms = '/settings/member-registry/webforms',
  MemberRegistrySettingsProfiles = '/settings/member-registry/profiles',
  MemberRegistrySettingsTitles = '/settings/member-registry/titles',
  MemberRegistrySettingsMyPage = '/settings/member-registry/mypage',
  FundraiserSettings = '/settings/fundraiser',
  Fundraiser = '/gifts/fundraiser',
  FundraiserDetail = '/gifts/fundraiser',
  SettingsFundraiserSettings = '/settings/fundraiser/settings',
  FundraiserSettingsDetail = '/settings/fundraiser',
  Organization = '/organization/customer',
  OrganizationFee = '/organization/customer/fee',
  OrganizationBoard = '/organization/customer/board',
  OrganizationRole = '/organization/customer/role',
  OrganizationDistricts = '/organization/districts',
  OrganizationMyDistrict = '/mydistrict',
  OrganizationAssocations = '/organization/associations',
  OrganizationMyAssociation = '/myassociation',
  AssociationDetail = '/associations/register',
  InvoiceMission = '/invoicing/mission',
  InvoiceMissionDetail = '/invoicing/mission',
  InvoiceMissionDetailSendingType = '/invoicing/mission',
  InvoiceTemplate = '/invoicing/template',
  Support = '/support/billing',
  InstallCustomer = '/support/install-customer',
  // Supportens bokade utskicksuppdrag (snd_missions) – bara för fsupport.
  BookedSendingMissions = '/support/sending-missions',
  CustomerSettings = '/settings/customer',
  AdminInvoiceGroupSettings = '/settings/invoicegroup',
  AdminInvoiceTemplateSettings = '/settings/invoicegroup/invoice-templates',
  Statistics = '/statistics/overview',
  StatisticsMemberProgress = '/statistics/member',
  StatisticsReports = '/statistics/reports',
  StatisticsReportsSnapshot = '/statistics/reports/snapshot',
  StatisticsReportsMembers = '/statistics/reports/members',
  StatisticsAgeAndGenderDistribution = '/statistics/reports/age-gender-distribution',
  StatisticsReportsSmsService = '/statistics/reports/sms-service',
  StatisticsTroubleshooting = '/statistics/troubleshooting',
  StatisticsTroubleshootingCategory = '/statistics/troubleshooting/:category',
  StatisticsIncome = '/statistics/income',
  MemberStripeStatus = '/stripe/status/members',
  StripeCustomer = '/stripe/status',
  MemberSwishStatus = '/swish/status/members',
  // Medgivanden ligger på prefixet /swish (default-vy) så sidomenyns NavLink markeras för båda flikarna
  // (medlemsfliken /swish/status/members är en undersökväg), precis som autogiro under /autogiro.
  SwishConsents = '/swish',
  Payments = '/invoicing/payments',
}

export enum AdminRoutesEnum {
  AdminOverview = '/admin/overview',
  SendingOrders = '/admin/sendingorder/list',
}

export enum MeRoutesEnum {
  MemberDashboard = '/me/dashboard',
  MemberEvents = '/me/events',
  MemberMyPage = '/me/mypage',
}
